import BikeCard from './BikeCard';

export default BikeCard;
